import React, { createContext, useState, useContext, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import lightTheme from '../../assets/theme/light';
import darkTheme from '../../assets/theme/dark';

export const themeContext = createContext<IThemeContext>({} as IThemeContext);

type Props = {
    children: React.ReactNode;
};

interface IThemeContext {
    toggleTheme: () => void;
    theme: 'light' | 'dark';
}

const STORAGE_KEY = 'shoppbud:theme';

const ThemeContext: React.FC<Props> = ({ children }) => {
    const [theme, setTheme] = useState<'light' | 'dark'>(() => {
        const storedTheme = localStorage.getItem(STORAGE_KEY);
        return storedTheme === 'dark' || storedTheme === 'light'
            ? storedTheme
            : 'light';
    });

    const toggleTheme = () => {
        setTheme((prev) => {
            const next = prev === 'light' ? 'dark' : 'light';
            localStorage.setItem(STORAGE_KEY, next);
            return next;
        });
    };

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);

    return (
        <themeContext.Provider value={{ theme, toggleTheme }}>
            <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
                {children}
            </ThemeProvider>
        </themeContext.Provider>
    );
};

function useTheme(): IThemeContext {
    const context = useContext(themeContext);
    const { toggleTheme, theme } = context;
    return {
        toggleTheme,
        theme,
    };
}

export { useTheme };
export default ThemeContext;
